<template>
    <div class="container">
        <div class="icon">(´･ω･)ﾉ(._.`)</div>
        <div>我怀疑你在乱访问页面呢</div>
        <div class="back-home" v-touch:tap="goToHome">回到首页</div>        
    </div>
</template>

<script>
    export default {
        methods: {
            goToHome(){
                this.$router.push({ name: 'Home' })
            }
        },
    }
</script>

<style lang="less" scoped>
    .container{
        background-color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .icon{
            margin-bottom: 20px;
            font-size: 50px;
        }
        .icon-size{
            &::before{
                font-size: 200px;
            }
        }
        .back-home{
            margin-top: 50px;
        }
    }
</style>